import Button from '../UI/button';

type Props = {
  imageUrl: string;
  title: string;
  createdBy: string;
  collaboratorsCount: number;
  description: string;
  alertPartners?: string;
  createdAt: string;
  onAccept?: () => void;
  onDecline?: () => void;
  hideSentInvitationActions?: boolean;
};

const TripInvitationNew = ({
  imageUrl,
  title,
  createdBy,
  collaboratorsCount,
  description,
  alertPartners = 'This invitation expires in 30 days!',
  createdAt,
  onAccept,
  onDecline,
  hideSentInvitationActions = false
}: Props) => {
  return (
    <div className='invitation-card'>
      <div className='invitation-card-image'>
        <img
          src={imageUrl}
          alt=''
        />
      </div>
      <div className='invitation-card-content'>
        <h6>{title}</h6>
        <ul className='invitation-card-list'>
          <li>
            <strong>Created by: </strong>
            <span>{createdBy}</span>
          </li>
          <li>
            <strong>Date of creation:</strong>
            <span>{createdAt}</span>
          </li>
          <li>
            <strong>Collaborators: </strong>
            <span>{collaboratorsCount} members</span>
          </li>
        </ul>
        <strong>Description:</strong>
        <div className='invitation-card-description'>
          <p>{description}</p>
        </div>
        <p className='alert-par'>{alertPartners}</p>
        {!hideSentInvitationActions && (
          <div className='invitation-card-actions'>
            <Button
              variant='outline-dark'
              onClick={onDecline}
            >
              Decline
            </Button>
            <Button
              variant='dark'
              onClick={onAccept}
            >
              Accept
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default TripInvitationNew;
